import React, { useEffect, useState } from "react";
import { Col, Row, Card, Button } from "antd";
import { Link } from "react-router-dom";
import InfoMenu from "../components/InfoMenu";
import BusableWidget, { VIEW_BY_LINK } from "../components/BusableWidget";
import { ReactComponent as Download } from "../assets/icons/Download.svg";
const Image1 = require("../assets/original/_DA_8860_low_res.jpg");

export default function OgdensMudgee() {
    const [activeLink, setActiveLink] = useState("tripPlanner");
    const [isTownlink, setisTownlink] = useState(false);
    const [townLink, setTownLink] = useState();
    const [routeSelection, setRouteSelection] = useState();

    useEffect(() => {
        document.body.classList.add("PageOgdensMudgee");
        return () => {
            document.body.classList.remove("PageOgdensMudgee");
        };
    }, []);

    useEffect(() => {
        // Parse the query parameters
        const queryParams = new URLSearchParams(window.location.search);
        // Check if 'timetables' query parameter is present and set to 'true'
        if (queryParams?.get('timetables') === 'true') {
          setActiveLink('timetables');
        }
        if (queryParams?.get('townlink')) {
          setisTownlink(true);
          setTownLink(queryParams?.get('townlink'));
        }
        if (queryParams?.get('rs')) {
          setRouteSelection(queryParams?.get('rs'));
        }
    }, []);

    // Town-link timetable links carry the route as rs=<routeId>; the widget takes
    // it as a path segment on the timetables view.
    const view = VIEW_BY_LINK[activeLink];
    const routeId = view === "timetables" ? routeSelection : null;

    return (
        <div className="OgdensMudgee PageSingle" style={{ paddingBottom: "50px" }}>
            {isTownlink ?
                <section
                    className="PageHero Cover"
                    style={{ backgroundImage: `url(${Image1})` }}
                >
                    <div className="AppContainer">
                        <h1 className="title" style={{ marginBottom: "8px" }}>
                            {townLink}
                        </h1>
                        <Button href="/town-link" size="small" className="mt-20 light" type="primary">Back to Town-link</Button>
                        <div className="InfoMenu">
                            <ul>
                                <li style={{borderRadius: '18px'}}><Link to="https://lms-prod-media-assets.s3.ap-southeast-2.amazonaws.com/21500_OGDENS_mudgee_tt_2021_RESTYLED_V2_2021_8aafc2f5c7.pdf" target="_blank"><Download /> Download Timetable</Link></li>
                            </ul>
                        </div>
                    </div>
                </section>
            :
                <section
                    className="PageHero Cover"
                    style={{ backgroundImage: `url(${Image1})` }}
                >
                    <div className="AppContainer">
                        <h1 className="title" style={{ marginBottom: "8px" }}>
                        Ogdens Mudgee
                        </h1>
                        <h2 className="title" style={{ marginBottom: "0" }}>
                            Mudgee | Gulgong | Goolma
                        </h2>
                        <InfoMenu activeLink={activeLink} setActiveLink={setActiveLink} />
                    </div>
                </section>
            }
            <div className="AppContainer">
                <Row gutter={[20, 0]}>
                    <Col xs={{ span: 24, order: 1 }} md={{ span: 24, order: 1 }}>
                        <Card bordered={false} className="CardEmbed">
                            <BusableWidget
                                operatorId="ogdens_mudgee"
                                view={view}
                                routeId={routeId}
                                search={window.location.search}
                            />
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
